import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { BlogPostCard } from '@/components/frontend/molecules/BlogPostCard'
import { useTranslation } from '@/hooks/useTranslation'
import type { PublicPost } from '@/types/frontend'

interface RelatedPostsProps {
  posts: PublicPost[]
}

export const RelatedPosts: React.FC<RelatedPostsProps> = ({ posts }) => {
  const { t } = useTranslation()

  if (posts.length === 0) return null

  return (
    <Section padding="lg" background="alt">
      <Container>
        <Stack gap="8">
          <Heading level="3" as="h2">{t('blog.related')}</Heading>
          <ResponsiveGrid cols="3" gap="4">
            {posts.map((post) => <BlogPostCard key={post.id} post={post} />)}
          </ResponsiveGrid>
        </Stack>
      </Container>
    </Section>
  )
}
